// Route path constants
export const PATHS = {
  // Public routes
  LOGIN: "/login",
  REGISTER: "/register",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password",
  ROOT: "/",

  // Protected routes
  DASHBOARD: "/dashboard",
  COMPONENTS: "/components",
  PROFILE: "/profile",
  SETTINGS: "/settings",
  CHANGE_PASSWORD: "/change-password",
  USER_LIST: "/user-list",
  MANAGE_USER: "/user-management/user",
  ROLES_PERMISSIONS: "/user-management/roles-permissions",
  COMPANY_SETUP: "/company-setup",
  ORGANIZATION: "/organization",
  ONBOARD: "/onboard",
  MORE_SOLUTIONS: "/more-solutions",
  ACTIVITY_LOG: "/activity-log",
  SURVEYS: "/surveys",

  ESG_TARGETS: "/esg/targets",
  ESG_DASHBOARD: "/esg/dashboard",
  ESG_TARGETS_SUMMARY: "/esg/targets/summary",
  ESG_REPORTS: "/esg/reports",
  ESG_REPORT: "/esg/report/:framework/:stepId",
  ESG_FRAMEWORKS: "/esg/frameworks",
  ESG_CUSTOM_DISCLOSURES: "/esg/custom-disclosures",

  SURVEY_TAKE: "/surveys/take",
  SURVEY_RESPONSE_DETAIL: "/surveys/responses/:responseId",
  STANDARD_SURVEY_NEW: "/surveys/standard/new",
  STANDARD_SURVEY_EDIT: "/surveys/standard/:surveyId",
  CUSTOM_SURVEY_NEW: "/surveys/custom/new",
  CUSTOM_SURVEY_EDIT: "/surveys/custom/:surveyId",
  NOTIFICATIONS: "/notifications",

  // Fallback
  NOT_FOUND: "*",
};

// Helper to check if path is public
export const isPublicPath = (path) => {
  const publicPaths = [
    PATHS.LOGIN,
    PATHS.REGISTER,
    PATHS.FORGOT_PASSWORD,
    PATHS.RESET_PASSWORD,
    PATHS.ROOT,
  ];
  return publicPaths.includes(path);
};
